import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useFormik } from 'formik';
import { FILL_RATE_TIME_OPTIONS, OPERATING_OPTIONS } from 'helpers/constans';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { getCommonSettingInventory, putCommonSettingInventory } from 'store/thunks';
import * as Yup from "yup";


interface Props {
    isOpen: boolean,
    onClose?: () => void,
}
const ModalCommonSetting = ({ isOpen, onClose }: Props) => {

    const { t } = useTranslation();

    const FILL_RATE_TIME_OPTIONS_LANG = FILL_RATE_TIME_OPTIONS?.map(
        (item: any) => ({ value: item?.value, label: t(item?.label) })
    );

    const OPERATING_OPTIONS_LANG = OPERATING_OPTIONS?.map(
        (item: any) => ({ value: item?.value, label: item?.label })
    );

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => {
        onClose && onClose();
    };

    const handleSubmit = async (values: any) => {
        setIsSaving(true);
        try {
            const data = {
                ipexcept_timer_forced_click: Number(values?.ipexcept_timer_forced_click),
                ipexcept_display_time_start: Number(values?.ipexcept_display_time_start?.value),
                ipexcept_display_time_end: Number(values?.ipexcept_display_time_end?.value),
                ipexcept_operating_probability: Number(values?.ipexcept_operating_probability),
                ipexcept_exclusion_time: Number(values?.ipexcept_exclusion_time || 0),
            };
            const res: any = await putCommonSettingInventory(data);
            setIsSaving(false);
            if (res?.code === 200) {
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                handleClose();
            } else {
                toast(`${res}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsSaving(false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const formik = useFormik({
        initialValues: {
            ipexcept_timer_forced_click: 0,
            ipexcept_display_time_start: OPERATING_OPTIONS_LANG[0],
            ipexcept_display_time_end: OPERATING_OPTIONS_LANG[24],
            ipexcept_operating_probability: 0,
            ipexcept_exclusion_time: 0,
        },
        validationSchema: Yup.object({
            ipexcept_timer_forced_click: Yup.number().required(),
            ipexcept_display_time_start: Yup.object({
                label: Yup.string(),
                value: Yup.string().nullable(),
            }).nullable(),
            ipexcept_display_time_end: Yup.object({
                label: Yup.string(),
                value: Yup.string().nullable(),
            }).nullable(),
            ipexcept_operating_probability: Yup.number().required(),
            ipexcept_exclusion_time: Yup.string().nullable()
        }),
        onSubmit: handleSubmit
    });

    const getCommonSettings = async () => {
        try {
            setIsLoading((_prev) => true);
            const response: any = await getCommonSettingInventory();
            setIsLoading((_prev) => false);
            const _settings = response?.data || {};
            const _values: any = {
                ipexcept_timer_forced_click: _settings?.ipexcept_timer_forced_click,
                ipexcept_display_time_start: OPERATING_OPTIONS_LANG?.find((item) => String(item?.value) === String(_settings?.ipexcept_display_time_start)) || null,
                ipexcept_display_time_end: OPERATING_OPTIONS_LANG?.find((item) => String(item?.value) === String(_settings?.ipexcept_display_time_end)) || null,
                ipexcept_operating_probability: _settings?.ipexcept_operating_probability,
                ipexcept_exclusion_time: _settings?.ipexcept_exclusion_time || 0,
            };
            formik.setValues(_values);
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    useEffect(() => {
        if (isOpen) {
            getCommonSettings();
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered={true} scrollable={false} size="md">
            <ModalHeader toggle={onClose} className="pb-1">
                {t('Common Settings')}
            </ModalHeader>
            <ModalBody>
                <form onSubmit={formik.handleSubmit}>
                    <Row className="mb-3 px-2">
                        <div className="border border-dashed border-primary py-3 position-relative position-relative" style={{ borderRadius: '8px' }}>
                            <span className="h6 position-absolute text-primary mb-0" style={{
                                top: 0,
                                transform: 'translate(-5px, -50%)',
                                backgroundColor: '#fff',
                                padding: '0 5px',
                            }}
                            >{t('Force Click (IP Exception Timer)')}</span>
                            <Col sm={12} className="mb-3 mt-2">
                                <div className="form-check form-switch mb-0">
                                    <Input className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="ipexcept_timer_forced_click"
                                        name="ipexcept_timer_forced_click"
                                        checked={!!formik.values.ipexcept_timer_forced_click}
                                        onChange={(event: any) => formik.setFieldValue("ipexcept_timer_forced_click", Number(event?.target.checked))}
                                    />
                                    <Label className="form-check-label" for="ipexcept_timer_forced_click">{t('Force Click (IP Exception Timer)')}</Label>
                                    {/* <TooltipCustom
                                                                title={t("The ad function operates only when the specified keywords are included in the referrer URL")}
                                                                className="d-inline-block vertical-align-middle ms-1"
                                                                style={{ transform: 'translateY(1px)' }}
                                                            >
                                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                                            </TooltipCustom> */}
                                </div>
                            </Col>
                            <Row>
                                <Col sm={6} className="mt-2 mb-2">
                                    <div>
                                        <label className="form-label">
                                            {t("Operating Time (start)")}
                                            <span className="text-danger"> *</span>
                                            <TooltipCustom
                                                title={t("The time period during which automatic clicks operate.") + " (" + formik.values.ipexcept_display_time_start?.label + " ~ 24:00)"}
                                                className="d-inline-block vertical-align-middle ms-1"
                                                style={{ transform: 'translateY(1px)' }}
                                            >
                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                            </TooltipCustom>
                                        </label>
                                        <DropdownOption
                                            name="ipexcept_display_time_start"
                                            dataList={OPERATING_OPTIONS_LANG || []}
                                            placeholder={`${t("Operating Time (start)")}...`}
                                            className="dropdown-status-rounded form-ph"
                                            classNamePrefix="name-prefix"
                                            initialValue={formik.values.ipexcept_display_time_start || OPERATING_OPTIONS_LANG[0]}
                                            onChangeSelect={(event: any) => formik.setFieldValue("ipexcept_display_time_start", event)}

                                        />
                                    </div>
                                </Col>
                                <Col sm={6} className="mt-2 mb-2">
                                    <div>
                                        <label className="form-label">
                                            {t("Operating Time (end)")}
                                            <span className="text-danger"> *</span>
                                            <TooltipCustom
                                                title={t("The time period during which automatic clicks operate.") + " (00:00 ~ " + formik.values.ipexcept_display_time_end?.label + ")"}
                                                className="d-inline-block vertical-align-middle ms-1"
                                                style={{ transform: 'translateY(1px)' }}
                                            >
                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                            </TooltipCustom>
                                        </label>
                                        <DropdownOption
                                            name="ipexcept_display_time_end"
                                            dataList={OPERATING_OPTIONS_LANG || []}
                                            placeholder={`${t("Operating Time (end)")}...`}
                                            className="dropdown-status-rounded form-ph"
                                            classNamePrefix="name-prefix"
                                            initialValue={formik.values.ipexcept_display_time_end || OPERATING_OPTIONS_LANG[24]
                                            }
                                            onChangeSelect={(event: any) => formik.setFieldValue("ipexcept_display_time_end", event)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={6} className="mt-2 mb-2">
                                    <div className="position-relative">
                                        <label className="form-label">
                                            {t("Operating Probability")}
                                            <span className="text-danger"> *</span>
                                            <TooltipCustom
                                                title={t("The probability of automatic clicks operating during the specified time period.")}
                                                className="d-inline-block vertical-align-middle ms-1"
                                                style={{ transform: 'translateY(1px)' }}
                                            >
                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                            </TooltipCustom>
                                        </label>
                                        <Input
                                            type="text"
                                            id="ipexcept_operating_probability"
                                            name="ipexcept_operating_probability"
                                            autocomplete={false}
                                            value={formik.values.ipexcept_operating_probability}
                                            placeholder={`${t("Operating Probability")}...`}
                                            onChange={(event: any) => {
                                                const input = event.target.value;
                                                const onlyNumbers = input.replace(/\D/g, "");
                                                const s = Number(onlyNumbers);
                                                formik.setFieldValue("ipexcept_operating_probability", s);
                                            }}
                                        />
                                        <div
                                            style={{ bottom: 10, right: 20 }}
                                            className="position-absolute fw-medium text-secondary"
                                        >
                                            {t('%')}
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={6} className="mt-2 mb-2">
                                    <div>
                                        <label className="form-label">
                                            {t("Exclusion Time (minutes)")}
                                            <span className="text-danger"> *</span>
                                            <TooltipCustom
                                                title={t("The time period during which automatic clicks will not operate after an automatic click occurs.")}
                                                className="d-inline-block vertical-align-middle ms-1"
                                                style={{ transform: 'translateY(1px)' }}
                                            >
                                                <i className="ri-question-line align-bottom text-secondary" ></i>
                                            </TooltipCustom>
                                        </label>
                                        <div className="position-relative">
                                            <Input
                                                type="text"
                                                id="ipexcept_exclusion_time"
                                                name="ipexcept_exclusion_time"
                                                value={formik.values.ipexcept_exclusion_time}
                                                placeholder={`${t("Exclusion Time (minutes)")}...`}
                                                onChange={(event: any) => {
                                                    const input = event.target.value;
                                                    const onlyNumbers = input.replace(/\D/g, "");
                                                    const s = Number(onlyNumbers);
                                                    formik.setFieldValue("ipexcept_exclusion_time", s);
                                                }}
                                            />
                                            <div
                                                style={{ bottom: 10, right: 20 }}
                                                className="position-absolute fw-medium text-secondary"
                                            >
                                                {t('minutes')}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Row>
                    <Row>
                        <Col sm={12} className="text-end">
                            <button className="btn btn-soft-secondary rounded-pill fs-14 me-2" type="button" color="light"
                                style={{ width: '100px' }}
                                onClick={() => handleClose()}
                                disabled={isSaving}>
                                {t('Button Close')}
                            </button>
                            <button className="btn btn-primary rounded-pill fs-14" type="submit"
                                disabled={isSaving}
                                style={{ width: '100px' }}
                            >
                                {isSaving ? <Spinner size="sm" className="me-2"></Spinner> : t('Button Save')}
                            </button>
                        </Col>
                    </Row>
                </form>
            </ModalBody>
        </Modal >
    )
}

export default ModalCommonSetting
